import Antd from 'ant-design-vue';
import '@/assets/less'



export default Antd